import styled from "styled-components";
import { GoPrimitiveDot } from "react-icons/go";
import { Container } from "../../../components/navbar/Nav.styles";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";

const ProductComp = () => {
  return (
    <ContainerProd>
      <Wrapper>
        <div>
          <div className="web__content">
            <h1>
              You need a <span className="beta__life">Beta Life</span>
            </h1>
            <p>
              Beta Life is a product for Relocation. This is a target/locked
              savings plan that can help you save towards your relocation plan.
              This is a 2in1 product, which helps to save and at the same time
              provide adequate proof of funds.
            </p>
          </div>
          <div className="first__image">
            <img
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636147/invest-trust/Rectangle_49_hsc99y.png"
              alt="betalife"
            />
          </div>

          <h2 className="web__features">Features</h2>
          <BenefitItem outline>
            <GoPrimitiveDot className="bullet__point" />
            <span>Minimum savings of 100,000 montly.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Locked savings with tenor of 3 - 12 months </span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Interest rate for proof of funds is 4% per month</span>
          </BenefitItem>
          <div className="start__saving">
            <Button to="/submit">Start Saving</Button>
          </div>
          <div style={{ marginTop: "4rem" }}>
            <img
              className="web__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_qxotap.png"
              alt="betalife"
            />
          </div>
        </div>
        <BenefitComp>
          <div>
            <div className="mobile__content">
              <h1>
                You need a <span className="beta__life">Beta Life</span>
              </h1>
              <p>
                Beta Life is a product for Relocation. This is a target/locked
                savings plan that can help you save towards your relocation
                plan. This is a 2in1 product, which helps to save and at the
                same time provide adequate proof of funds.
              </p>
            </div>
            <img
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/young-black-man-with-leather-case-travel-tourist-concept_1194-20109_1_phd0ph.png"
              alt="betalife"
            />
          </div>
          <h2>Benefits</h2>
          <BenefitItem>
            <GoPrimitiveDot
              className="bullet__point__benefit"
            />
            <span>
              13% per annum Return on investment for locked savings account
              holder.
            </span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot
              className="bullet__point__secondary"
            />
            <span>
              This plan grants you the easy and better life you want through
              relocation within 3months.
            </span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot
             className="bullet__point"
            />
            <span>
              Easy access to proof of funds with low interest at 3.5% monthly.
            </span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Upfront interest on your locked savings.</span>
          </BenefitItem>
          <div style={{ marginTop: "12rem" }}>
            <img
              className="mobile__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_qxotap.png"
              alt="betalife"
            />
          </div>
        </BenefitComp>
      </Wrapper>
    </ContainerProd>
  );
};

export default ProductComp;

export const ContainerProd = styled(Container)`
  transform: translateY(-8rem);
  background-color: #dbdbf9;
`;

export const Wrapper = styled.div`
  .web__view {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 43px;
  margin-bottom: 2rem;

  img {
    max-width: 100%;
  }

  div:nth-of-type(1) {
    // border: 3px solid teal;
  }

  div:nth-of-type(1) h1 {
    font-family: "Futura";
    font-size: 3rem;
    font-weight: 200;
  }
  div:nth-of-type(1) p {
    font-size: 20px;
    padding-right: 1.5rem;
    margin-bottom: 2rem;
  }

  .beta__life {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .start__saving {
    margin-top: 4rem;
  }
  .start__saving a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  .bullet__point {
    font-size: 32px;
    color: #1b20e5;
  }
  .bullet__point__benefit {
    font-size: 32px;
    color: #1b20e5;
    margin-top: -1.5rem;
    margin-left: 0.1rem;
  }
  .bullet__point__secondary {
    font-size: 32px;
    color: #1b20e5;
    margin-top: -1.5rem;
    margin-left: 0.1rem;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;

    .start__saving {
      display: flex;
      justify-content: center;
    }
    .web__content {
      display: none;
    }
    .web__view {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 3rem;
      text-align: center;
    }
    .beta__life {
      display: block;
    }
    div:nth-of-type(1) p {
      font-size: 20px;
      padding-right: 0rem;
      padding-left: 0rem;
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    grid-template-columns: 1fr;
    .first__image {
      transform: translateY(-10rem);
    }
    .web__features {
      transform: translateY(-10rem);
      margin-bottom: -8rem;
    }

    div:nth-of-type(1) h1 {
      font-size: 2rem;
      text-align: center;
      line-height: 40px;
    }
    .bullet__point {
      margin-top: 0.4rem;
      font-size: 16px;
      color: #1b20e5;
    }
    .bullet__point__benefit {
      font-size: 16px;
      color: #1b20e5;
      margin-top: 0.4rem;
      margin-left: 0.1rem;
    }
    .bullet__point__secondary {
      font-size: 20px;
      color: #1b20e5;
      margin-top: 0.4rem;
      margin-left: 0.1rem;
    }
  }
`;

export const BenefitComp = styled.div`
  .mobile__content {
    display: none;
  }
  .mobile__view {
    display: inline-block;
  }
  div: nth-of-type(2);
  @media screen and (max-width: 991px) {
    grid-row-start: 1;
    grid-row-end: 3;
    .mobile__content {
      display: block;
    }
    .mobile__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {

  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  // width: 577px;

  .product__dot {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary};
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  span {
    font-size: 20px;
    padding-right: 7rem;
  }
  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    align-items: flex-start;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  span {
    font-size: 20px;
    padding-right: 1rem;
  }
`;
